import { useState, useEffect, useContext } from 'react';
import { Link as _Link } from 'react-router-dom';
import styled from 'styled-components/macro';
import { COLORS } from '../../constants';
import Color from 'color2';
import { useParams, useHistory } from 'react-router-dom';
import { FirebaseContext } from '../../contexts/firebase';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { DataGrid } from '@mui/x-data-grid';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import NewEventModal from './NewEventModal';

export const Link = styled(_Link)`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 12px;
  box-sizing: border-box;

  &:nth-child(odd) {
    background-color: ${new Color(COLORS.BACKGROUND).lighten(0.1)};
  }
`;

export const Id = styled.div`
  font-size: 0.7em;
  font-style: italic;
  color: ${new Color(COLORS.TEXT).lighten(0.1)};
`;

export const EventList = () => {
  const { database } = useContext(FirebaseContext);
  const { clientId } = useParams();
  const history = useHistory();

  const [rows, setRows] = useState([]);
  const cols = [
    { field: 'id', headerName: 'ID', width: 150 },
    { field: 'displayName', headerName: 'Display Name', flex: 1 },
  ];

  useEffect(() => {
    return database
      .collection(`/clients/${clientId}/events`)
      .onSnapshot(docs => {
        setRows(
          docs.docs.map(doc => {
            const { displayName } = doc.data();
            return {
              id: doc.id,
              displayName,
            };
          }),
        );
      });
  }, [database, clientId]);

  const [modal, setModal] = useState(false);

  const handleCloseModal = () => {
    setModal(false);
  };

  return (
    <Box>
      <Box
        sx={{
          display: { xs: 'box', md: 'flex' },
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="h2" sx={{ pr: 3 }}>
          Events
        </Typography>

        <Fab color="primary" size="small" aria-label="add">
          <AddIcon onClick={() => setModal(true)} />
        </Fab>

        <NewEventModal open={modal} onClose={handleCloseModal} />
      </Box>

      <Box sx={{ width: '100%', mt: 3 }}>
        <DataGrid
          rows={rows}
          columns={cols}
          autoHeight={true}
          density="compact"
          disableSelectionOnClick={true}
          pageSize={25}
          onRowClick={row => {
            console.log('row', row);
            history.push(`/clients/${clientId}/events/${row.id}`);
          }}
          sx={{
            '& .MuiDataGrid-cell': {
              cursor: 'pointer',
              outline: 'none',
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default EventList;
